import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AppButton,
  Box,
  RoundPendingIcon,
  Text,
} from '@common-fe/common-fe';

import { ModalWrapper } from '@/components';

const HEADER = 'You cannot add a new bank account';
const DESCRIPTION = `You already have bank account verification pending,
 so you cannot add a new one until its status changes`;

interface Props {
  visible: boolean;
  onSetVisible: (value: boolean) => void;
  onSubmit: () => void;
}

export const PlaidPendingAccountModal: React.FC<Props> = ({
  visible,
  onSetVisible,
  onSubmit,
}) => {
  const { t } = useTranslation();
  return (
    <ModalWrapper testId="PlaidPendingAccountModal" visible={visible} onSetVisible={onSetVisible}>
      <Box align="center" pad={{ vertical: 'spacing24', horizontal: 'spacing48' }}>
        <RoundPendingIcon color="warning" />
        <Text
          data-testid="PlaidPendingAccountModal_modal_header"
          margin={{ vertical: 'spacing12' }}
          textAlign="center"
          size="24px"
          weight={700}
        >
          {t(HEADER)}
        </Text>

        <Text
          data-testid="PlaidPendingAccountModal_modal_help-text"
          margin={{ bottom: 'spacing24' }}
          textAlign="center"
        >
          {t(DESCRIPTION)}
        </Text>

        <Box direction="row">
          <AppButton
            testId="PlaidPendingAccountModal_modal_submit"
            onClick={onSubmit}
            width="200px"
          >
            {t('Got It')}
          </AppButton>
        </Box>
      </Box>
    </ModalWrapper>
  );
};
